import type { FeatureFlagDefinition, PlatformTag } from '@/types/feature-flag';

export interface TenantFeatureFlagState {
  enabled: boolean;
  configJson: Record<string, unknown> | null;
  updatedBy: string | null;
  updatedAt: string | null;
}

export type TenantFeatureFlagMap = Record<string, TenantFeatureFlagState>;

export interface TenantFeatureFlagsResponse {
  tenantKey: string;
  flags: TenantFeatureFlagMap;
  definitions: FeatureFlagDefinition[];
}

export interface UpdateTenantFeatureFlagBody {
  enabled?: boolean;
  configJson?: Record<string, unknown> | null;
  // Definition metadata. The tenant PATCH writes the flag's value and its
  // definition on one endpoint, so these ride along with the value fields.
  label?: string;
  description?: string | null;
  platformTag?: PlatformTag;
}

export interface UpdateTenantFeatureFlagResponse {
  tenantKey: string;
  featureKey: string;
  enabled: boolean;
  configJson: Record<string, unknown> | null;
}

export interface ConfigFieldDescriptor {
  key: string;
  label: string;
  inputType: 'number';
  min?: number;
  max?: number;
  helpText?: string;
}

export const TENANT_FLAG_CONFIG_FIELDS: Record<string, ConfigFieldDescriptor[]> = {
  birthdayCollection: [
    {
      key: 'promptCadenceDays',
      label: 'Prompt cadence (days)',
      inputType: 'number',
      min: 1,
      max: 365,
      helpText:
        'How many days between re-showing the prompt to a user who has not yet submitted or dismissed.',
    },
  ],
  basketItemLimits: [
    {
      key: 'soloMaxItems',
      label: 'Max items per bag',
      inputType: 'number',
      min: 1,
      max: 999,
      helpText:
        'Most items a customer can have in one bag. 999 is the Olo maximum, which also applies when the flag is off.',
    },
    {
      key: 'groupOrderMaxItems',
      label: 'Max items per group order',
      inputType: 'number',
      min: 1,
      max: 999,
      helpText:
        'Most items one group order can hold, counting the host and every guest together, submitted or not. 999 is the Olo maximum, which also applies when the flag is off.',
    },
  ],
};
